import axios from "axios";
import { useEffect, useState } from "react";
import { Category, Products } from "../../../home";
import Swal from "sweetalert2";
import resizeImage from "../../../../const/FileResizer";

const AdminProductPost = () => {
  const [data, setData] = useState<Products>({
    id: 0,
    src: "",
    originName: "",
    savedName: "",
    title: "",
    categoryId: 1,
    created: "",
    updated: "",
    orderId: 0,
  });
  const [category, setCategory] = useState<Category[] | null>(null);
  const [thumb, setThumb] = useState<File | null>(null);

  useEffect(() => {
    axios
      .get(`/api/category`)
      .then((res) => {
        if (res.data.code === "0000") {
          setCategory(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, []);

  const productPostFnc = async () => {
    const formData = new FormData();

    if (!thumb) {
      window.alert("이미지 등록 필요");
      return false;
    }

    if (!data.title) {
      window.alert("기본정보 등록 필요");
      return false;
    }

    const resizedImage = await resizeImage(thumb, 500, 500);

    thumb && formData.append("file", resizedImage);
    formData.append("title", data.title);
    formData.append("categoryId", data.categoryId.toString());
    formData.append("id", data.id.toString());

    await axios
      .post(`/api/product`, formData)
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "제품 등록 완료",
            text: "제품 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/admin/product"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/admin/product"));
      });
  };

  return (
    <div className=" relative w-full h-full">
      <div className="flex justify-between items-center">
        <h4>제품 추가</h4>
      </div>
      <div className="relative w-full h-full bg-white border shadow-md py-10 px-5 rounded-lg my-5">
        {category && (
          <div
            className={`relative w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 text-center mb-5`}
          >
            {category.map((v, i) => (
              <div
                key={i}
                onClick={() => setData({ ...data!, categoryId: v.id })}
                className={
                  v.id === data?.categoryId
                    ? "relative w-full h-full border border-primary bg-primary text-white py-1.5 cursor-pointer"
                    : "relative w-full h-full border border-primary bg-transparent text-primary py-1.5 cursor-pointer"
                }
              >
                <p className="font-light">{v.name}</p>
              </div>
            ))}
          </div>
        )}
        <div className="relative w-full h-full grid lg:grid-cols-2 gap-5">
          <div className=" relative w-full h-auto mx-auto">
            <label htmlFor="file">
              {data.src.length > 0 && (
                <img
                  src={data.src}
                  alt="제품 이미지 미리보기"
                  className="border relative w-auto h-full max-h-[550px] mx-auto"
                />
              )}
            </label>
          </div>
          <div className=" relative w-full h-full grid grid-rows-2 items-center gap-2">
            <div>
              <p>제품명</p>
              <input
                type="text"
                placeholder="제품명을 입력해주세요."
                defaultValue={data.title}
                onChange={(e) => setData({ ...data, title: e.target.value })}
              />
            </div>
            <div>
              <p>이미지업로드</p>
              <input
                type="file"
                accept="image/*"
                id="file"
                defaultValue={""}
                onChange={(e) => {
                  e.target.files && setThumb(e.target.files[0]);
                  e.target.files &&
                    setData({
                      ...data,
                      src: URL.createObjectURL(e.target.files[0]),
                    });
                }}
              />
            </div>
          </div>
        </div>
        <button
          onClick={productPostFnc}
          className=" relative w-full h-fit py-2 bg-primary text-white rounded-md mt-5"
        >
          <h5 className="font-light">등록하기</h5>
        </button>
      </div>
    </div>
  );
};

export default AdminProductPost;
